@let vm = vm$ | async;
@if (vm) {
  <div class="analytics-page-component">
    @if (vm.doesUserHaveDashboardAccess) {
      <div class="dashboard">
        <div class="d-flex justify-content-between">
          <h2>AOM Inventory Gap Dashboard</h2>
        </div>
        <app-report
          [url]="dashboardUrl"
          [token]="vm.token"
          [height]="dashboardHeight"
        ></app-report>
      </div>
    } @else {
      <app-unauthorized-page></app-unauthorized-page>
    }
  </div>
}
